module.exports = __webpack_public_path__ + "card_view.c594b65e.webp";